require('./src/Path.Transform');
require('./src/Path.Drag');
require('./src/MultiPoly.Drag');

module.exports = L.Path.Drag;



//////////////////
// WEBPACK FOOTER
// ./~/leaflet-path-drag/index.js
// module id = 288
// module chunks = 0